import { Env, readFromEnv } from '@cinch-nx/environments'
import {
  SegmentEventsTypes,
  TrackingEventTypes,
  useAnalytics,
} from '@cinch-nx/shared-analytics'
import { datadogRum } from '@datadog/browser-rum'

const triggerEvent = (type: string, eventName: string, data: object) => {
  const { trackEvent } = useAnalytics.getState()

  try {
    trackEvent({
      type: type as Exclude<TrackingEventTypes, TrackingEventTypes.IDENTIFY>,
      eventName,
      data,
    })
    datadogRum.addAction(eventName, data)
  } catch (error) {
    datadogRum.addError(new Error(`Trigger Segment Event: ${eventName}`), {
      error: (error as Error).message,
      context: {
        type,
        eventName,
        data,
      },
    })
  }
}

const triggerSegmentTracking = (data: object) => {
  const EnableSegmentTrackingInUsedCars =
    readFromEnv(Env.EnableSegmentTrackingInUsedCars) === 'true'
  if (!EnableSegmentTrackingInUsedCars) {
    return
  }

  triggerEvent(
    TrackingEventTypes.TRACK,
    SegmentEventsTypes.SEARCH_FILTERS_APPLIED,
    data,
  )
}

export const TriggerEvents = {
  triggerSegmentTracking,
}
